// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__BTFFv","icon":"index_icon__dGJ3u"};